import React, { Component } from "react";
import { Container, Row, Col, Card, CardBody } from "reactstrap";

import { withRouter } from "react-router-dom";
import SimpleReactValidator from "simple-react-validator";
import { compose } from "redux";
import ProductImageList from "./ImageList";
import ProductImageUpdateForm from "./ImageUpdateForm";
import { ADD_NEW, DELETE } from "constants/commonConstants";
import { confirmBox } from "helpers/messageHelper";

import { createStructuredSelector } from "reselect";
import { connect } from "react-redux";
import injectReducer from "helpers/injectReducer";
import injectSaga from "helpers/injectSaga";
import productDetailReducer from "store/ProductDetail/reducer";
import productDetailSaga from "store/ProductDetail/saga";
import {
  deleteProductImagesByProductDetailIdRequest,
  getProductImagesByProductDetailIdRequest,
} from "store/actions";

const productDetailKey = "ProductDetail";

const withProductDetailReducer = injectReducer({
  key: productDetailKey,
  reducer: productDetailReducer,
});
const withProductDetailSaga = injectSaga({
  key: productDetailKey,
  saga: productDetailSaga,
});

class Index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      formDialog: false,
      deleteImages: [],
    };

    this.validator = new SimpleReactValidator();
  }

  // delete button clicked
  handleDeleteButtonClicked = async () => {
    const response = await confirmBox();
    if (response) {
      const deleteImages = this.state.deleteImages;
      this.props.deleteProductImagesByProductDetailIdRequest(
        this.props.match.params.id,
        deleteImages
      );
    }
  };

  onProductDetailInsertUpdateSuccess = () => {
    this.setState({
      formDialog: false,
    });
  };

  viewProductDetail = () => {
    this.setState({
      formDialog: true,
    });
  };

  handleOnChangeCheckBox = (e, productImage) => {
    const deleteImages = this.state.deleteImages;
    const deleteImageFind = deleteImages.includes(productImage);

    if (e.target.checked) {
      if (!deleteImageFind) {
        deleteImages.push(productImage);
      }
    } else {
      if (deleteImageFind) {
        this.setState({
          deleteImages: deleteImages.filter((image) => image !== productImage),
        });
      }
    }
  };

  render() {
    return (
      <React.Fragment>
        <Container fluid className="pt-4">
          <ProductImageUpdateForm
            productDetailId={this.props.match.params.id}
            formDialog={this.state.formDialog}
            closeModal={() => this.onProductDetailInsertUpdateSuccess()}
          />
          <Row>
            <Col>
              <Card>
                <CardBody>
                  <div className="d-flex justify-content-between flex-column flex-sm-row">
                    <h4 className="mt-0 page-title">Product Detail</h4>
                    <div>
                      <button
                        className="btn btn-primary waves-effect waves-light mx-2"
                        onClick={() => this.viewProductDetail()}
                      >
                        {ADD_NEW}
                      </button>
                      <button
                        className="btn btn-dark waves-effect waves-light mx-2"
                        onClick={() => this.handleDeleteButtonClicked()}
                      >
                        {DELETE}
                      </button>
                    </div>
                  </div>

                  <ProductImageList
                    onChangeCheckBox={this.handleOnChangeCheckBox}
                    productDetailId={this.props.match.params.id}
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </React.Fragment>
    );
  }
}

const mapStatetoProps = createStructuredSelector({});

const withConnect = connect(mapStatetoProps, {
  deleteProductImagesByProductDetailIdRequest,
  getProductImagesByProductDetailIdRequest,
});

export default compose(
  withConnect,
  withProductDetailReducer,
  withProductDetailSaga,
  withRouter
)(Index);
